import React from 'react';
import ContentControlSection from '../../../sections/AdminDashboard/Configuration/ContentControl';

const ContentControl = () => <ContentControlSection />;

export default ContentControl;
